import React, { useState, useRef } from 'react';
import axios from 'axios';
import './Otp.css';
import { useNavigate, useLocation } from 'react-router-dom';

const OtpVerificationPage = () => {
  const history = useNavigate();
  const location = useLocation();
  const email = location?.state?.email || '';

  const [otp, setOtp] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const inputRef = useRef();

  if (!email) {
    return (
      <div style={{ padding: 20 }}>
        <h2>Invalid Access</h2>
        <p>Email not provided. Please go back and register again.</p>
      </div>
    );
  }

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const response = await axios.post('https://metalzulu-backend.onrender.com/api/v1/users/verify-otp', {
        email,
        otp,
      });

      console.log(response);
      alert(response.data.message); // "OTP verified successfully"
      history('/login');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Failed to verify OTP. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    setOtp(value);
  };

  const getMaskedDisplay = () => {
    const length = otp.length;
    const stars = '*'.repeat(6 - length);
    return otp + stars;
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Verify OTP</h2>
        <p style={styles.subtext}>
          Enter the 6-digit OTP sent to <strong>{email}</strong>
        </p>
        <form onSubmit={handleOtpSubmit}>
          <div
            onClick={() => inputRef.current.focus()}
            style={styles.maskedInput}
          >
            <input
              type="text"
              value={otp}
              onChange={handleChange}
              maxLength={6}
              ref={inputRef}
              style={styles.hiddenInput}
            />
            {getMaskedDisplay()}
          </div>

          {error && <div style={styles.error}>{error}</div>}
          <button type="submit" style={styles.button} disabled={isSubmitting}>
            {isSubmitting ? 'Verifying...' : 'Verify OTP'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f4f7fa',
    padding: '20px',
  },
  card: {
    background: '#fff',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%',
  },
  title: {
    marginBottom: '10px',
  },
  subtext: {
    color: '#666',
    marginBottom: '20px',
    fontSize: '14px',
  },
  maskedInput: {
    width: '100%',
    padding: '12px',
    fontSize: '24px',
    letterSpacing: '10px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    marginBottom: '12px',
    background: '#f9f9f9',
    cursor: 'text',
    userSelect: 'none',
    textAlign: 'center',
  },
  hiddenInput: {
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
  },
  button: {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    background: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  error: {
    color: 'red',
    marginBottom: '10px',
    fontSize: '14px',
  },
};

export default OtpVerificationPage;
